<template>
    <div>
        <div class="inline-form-group">
            <el-form-item label="Wyświetl filtry"
                          :error="errors['show_filter_bar']">
                <el-switch v-model="form.show_filter_bar"></el-switch>
            </el-form-item>
        </div>
        <el-collapse class="formset__list">
            <div v-for="section, i in form.sections" class="formset__item">
                <el-collapse-item :name="i">
                    <template slot="title">
                        <formset-header :label="`${getCategoryName(section.category) || 'Nowa sekcja'}`"
                                        :items.sync="form.sections"
                                        :errors="checkForErrors(errors.sections, [i])"
                                        :index="i"/>
                    </template>
                    <div class="inline-form-group">
                        <el-form-item label="Kolor tła"
                                      :error="errors.sections && errors.sections[i]['bg_color']">
                            <el-color-picker v-model="section.bg_color"></el-color-picker>
                        </el-form-item>
                        <el-form-item label="Kolor tekstu"
                                      :error="errors.sections && errors.sections[i]['text_color']">
                            <el-color-picker v-model="section.text_color"></el-color-picker>
                        </el-form-item>
                        <el-form-item label="Wyświetlaj pasek filtrów"
                                      :error="errors.sections && errors.sections[i]['show_tags_bar']">
                            <el-switch v-model="section.show_tags_bar"></el-switch>
                        </el-form-item>
                    </div>
                    <el-form-item label="Edycja"
                                  :error="errors.sections && errors.sections[i]['edition']"
                                  required>
                        <el-select filterable
                                   v-model="section.edition"
                                   placeholder="Edycja">
                            <el-option v-for="edition in $store.state.editions"
                                       :key="edition.id"
                                       :label="edition.year"
                                       :value="edition.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Kategoria"
                                  :error="errors.sections && errors.sections[i]['category']">
                        <el-select class="fluid"
                                   filterable
                                   v-model="section.category"
                                   placeholder="Kategoria">
                            <el-option
                                    v-for="item in categories"
                                    :key="item.id"
                                    :label="item.name_pl"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-collapse-item>
            </div>
        </el-collapse>
        <el-button @click="addSection"
                   type="primary"
                   class="fluid">
            Dodaj sekcję
        </el-button>
    </div>
</template>
<script>
    import {StandCategory} from '@/api'

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                categories: []
            }
        },
        mounted () {
            this.fetchData()
        },
        methods: {
            addSection () {
                const blankObject = {}
                if (!Array.isArray(this.form.sections)) {
                    this.$emit('update:form', {
                        ...this.form,
                        sections: [
                            blankObject
                        ]
                    })
                } else {
                    this.form.sections.push(blankObject)
                }
            },
            fetchData () {
                this.$store.dispatch('fetchEditions')
                StandCategory.fetch().then(response => {
                    this.categories = response.data
                })
            },
            getCategoryName (id) {
                const category = this.categories.find(category => category.id === id)
                if (category) {
                    return category.name_pl
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .section {
        background: #f9f9f9;
        padding: 30px 0;
        border: 1px solid #e2e2e2;
        position: relative;
        margin-bottom: 20px;
        cursor: pointer;
        &__remove-button {
            position: absolute;
            cursor: pointer;
            z-index: 1;
            top: 0;
            border-radius: 50%;
            padding: 8px 10px;
            right: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// StandsWidget.vue?5981db60